/* eslint-disable import/prefer-default-export */
import * as types from './actionTypes';

export function setLanguage(payload) {
  return {
    type: types.SET_LANGUAGE,
    payload,
  };
}
